import CheckBox from 'ageas-react-component-checkbox'
import Link from 'ageas-react-component-link'
import { DocumentToList } from '../../../@types/SubmitProposal'
import { useCancelDigitalSignatureProcessStore } from '../../../Stores/useCancelDigitalSignatureProcessStore'
import { usePolicyDocumentsSelectedStore } from '../../../Stores/usePolicyDocumentsSelectedStore'
import { useRefreshDigitalSignatureStatusStore } from '../../../Stores/useRefreshDigitalSignatureStatusStore'
import { useSubmitProposalStore } from '../../../Stores/useSubmitProposalStore'
import { removeDuplicatesDocuments } from '../../../utils/validates'
import { useDownloadDocuments } from '../../SimulationReport/useDownloadDocuments'

type Props = {
  check: any
  handleCheckbox: (value: any) => void
}

export const SubmitProposalDocuments = ({ check, handleCheckbox }: Props) => {
  const { submitProposal } = useSubmitProposalStore()
  const { downloadFileFromSubmitProposal } = useDownloadDocuments()
  const { addPolicyDocuments, deletePolicyDocuments } =
    usePolicyDocumentsSelectedStore()
  const { refreshDigitalSignatureStatus } =
    useRefreshDigitalSignatureStatusStore()
  const { cancelDigitalSignatureProcess } =
    useCancelDigitalSignatureProcessStore()

  const allDocuments = removeDuplicatesDocuments(
    [
      ...(submitProposal?.documents || []),
      ...(refreshDigitalSignatureStatus?.documents || []),
      ...(cancelDigitalSignatureProcess?.documents || []),
    ],
    'keyRef',
  ) as DocumentToList[]

  return (
    <>
      {allDocuments?.map((item, index) => (
        <div key={index} className="checkbox-wrapper">
          <CheckBox
            id={`ckeck-${item.keyRef}`}
            label={''}
            value={check?.[`ckeck-${item.keyRef}`] || '0'}
            onValueChanged={(key: any, value: any) => {
              if (value === '1') {
                addPolicyDocuments({
                  documentId: item.code,
                  idExternal: item.externalId,
                  keyRef: item.keyRef,
                  managementSystemCode: item.managementSystemCode,
                  name: item.name,
                })
              } else {
                deletePolicyDocuments(item.keyRef || '')
              }
              handleCheckbox({ [`ckeck-${item.keyRef}`]: value })
            }}
          />
          <Link
            icon="pdf"
            label={item.name}
            version={'4'}
            onValueChanged={() => {
              downloadFileFromSubmitProposal(item)
            }}
          />
        </div>
      ))}
    </>
  )
}
